import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ECGChartData } from 'pages/patientsManagement/components/ecgChart/ECGChart';

dayjs.extend(utc);
export default function changeData(ecgDatas: any): ECGChartData[] {
  const ecgDatas2: any = [];
  for (let i = 0; i < ecgDatas.length; i += 1) {
    const ecgData = ecgDatas[i];
    // if (ecgData.hr <= 0) {
    //   // eslint-disable-next-line no-continue
    //   continue;
    // }
    if (ecgData.hr === -301) {
      ecgData.hr = 300;
    }
    if (ecgData.hr === -316) {
      ecgData.hr = 40;
    }
    // start和finish误差是1秒
    const ecgTime: number = dayjs.utc(ecgData.recordTime).valueOf() - 1000;
    const pos128 = 1000 / 128;
    // 处理ecg数据,计算每秒的ecg图表数据点
    for (let ecgIndex = 0; ecgIndex < ecgData.ecg?.length; ecgIndex += 1) {
      const ecg: number = ecgData.ecg[ecgIndex];
      const x_ = Math.floor((ecgIndex + 1) * pos128) + ecgTime;
      // x是计算出
      const x: Date = dayjs.utc(x_).toDate();
      const y = ecg / ecgData.magnification;
      ecgDatas2.push({ x, y, hr: ecgData.hr });
    }
  }
  return ecgDatas2;
}
